import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'app-email-phone',
  templateUrl: './email-phone.component.html',
  styleUrls: ['./email-phone.component.scss']
})
export class EmailPhoneComponent extends FieldWrapper {
}
